'use strict';

var capitalize$1 = require('../node_modules/@material-ui/core/utils/capitalize.js');

var capitalize = capitalize$1;

module.exports = capitalize;
